export const PropositionTypeGroups = {
  PL: {
    acronyms: ['PL', 'PLS', 'PLC', 'PLN'],
    label: 'PL - Projeto de Lei',
    fullLabel: 'PL - Projeto de Lei (PL, PLS, PLC, PLN)',
  },
  PEC: {
    acronyms: ['PEC'],
    label: 'PEC - Proposta de Emenda à Constituição',
    fullLabel: 'PEC - Proposta de Emenda à Constituição',
  },
  PLP: {
    acronyms: ['PLP', 'PLS', 'PLC'],
    label: 'PLP - Projeto de Lei Complementar',
    fullLabel: 'PLP - Projeto de Lei Complementar (PLP, PLS, PLC)',
  },
  MPV: {
    acronyms: ['MPV', 'PLV'],
    label: 'MPV - Medida Provisória',
    fullLabel: 'MPV - Medida Provisória (MPV, PLV)',
  },
  PDL: {
    acronyms: ['PDL', 'PDS', 'PDN'],
    label: 'PDL - Projeto de Decreto Legislativo',
    fullLabel: 'PDL - Projeto de Decreto Legislativo (PDL, PDS, PDN)',
  },
  PRC: {
    acronyms: ['PRC', 'PRS', 'PRN'],
    label: 'PRC - Projeto de Resolução',
    fullLabel: 'PRC - Projeto de Resolução (PRC, PRS, PRN)',
  },
  REQ: {
    acronyms: ['REQ', 'RQS', 'RQN', 'RCP'],
    label: 'REQ - Requerimento',
    fullLabel: 'REQ - Requerimento (REQ, RQS, RQN, RCP)',
  },
  RIC: {
    acronyms: ['RIC'],
    label: 'RIC - Requerimento de Informação',
    fullLabel: 'RIC - Requerimento de Informação',
  },
  EMD: {
    acronyms: ['EMD'],
    label: 'EMD - Emenda',
    fullLabel: 'EMD - Emenda (Emenda aos seguintes tipos: PL, PLP, ECD, SCD)',
  },
  INC: {
    acronyms: ['INC'],
    label: 'INC - Indicação',
    fullLabel: 'INC - Indicação',
  },
  MSC: {
    acronyms: ['MSC'],
    label: 'MSC - Mensagem',
    fullLabel: 'MSC - Mensagem',
  },
  VET: {
    acronyms: ['VET'],
    label: 'VET - Veto',
    fullLabel: 'VET - Veto',
  },
}

export type PropositionTypeKeys = keyof typeof PropositionTypeGroups

// Helper function to convert the enum to options format for the filter
export const getPropositionTypeOptions = async () => {
  return Object.entries(PropositionTypeGroups).map(([key, group]) => ({
    key, // Use the group key as identifier
    value: group.label,
    acronyms: group.acronyms, // Include acronyms for the filter to use
  }))
}
